export * from './modal-base.interface';
export * from './modal-base.component';
